import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/main.vue'
import Partner from '../views/partner.vue'
import News from '../views/news.vue'
import NewsDetail from '../views/newsDetail.vue'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import Consultation from '../views/consultation.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/',
    component: Main
  },
  {
    path: '/consultation',
    component: Consultation
  },
  {
    path: '/partner',
    component: Partner
  },
  {
    path: '/news',
    component: News
  },
  {
    path: '/newsDetail',
    component: NewsDetail
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: Register
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router